<template>
  <el-dialog
    title="仓库创建"
    class="invoice-create"
    :visible.sync="callCreate.visible"
    :width="'1100px'"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <el-form
      label-position="right"
      label-width="110px"
      :inline="true"
    >
      <!-- <div>
      <el-form-item
        required
        label="店铺ID"
      >
        <div class="w220">
          {{ create.companyId }}
        </div>
      </el-form-item>
      <el-form-item
        required
        label="店铺名称"
      >
        <div class="w220">
          {{ create.companyName }}
        </div>
      </el-form-item>
    </div> -->

      <el-form-item
        required
        label="市场"
      >
        <el-select
          v-model="create.marketId"
          filterable
          @change="selectMarketChange"
        >
          <el-option
            v-for="item in marketList"
            :key="item.k"
            :label="item.v"
            :value="item.k"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        required
        label="仓库编号"
      >
        <el-input
          v-model="create.warehouseNo"
        />
      </el-form-item>
      <el-form-item
        required
        label="仓库名称"
      >
        <el-input v-model="create.warehouseName" />
      </el-form-item>
      <el-form-item
        label="所在地"
        readonly
        required
      >
        <el-input
          v-model="create.address"
          class="w220"
          type="textarea"
        />
      </el-form-item>
      <!-- <el-form-item
        label="地理位置"
        required
      >
        <div class="w200">
          {{ (create.lng && create.lat) ? '(' + create.lng +'，' + create.lat + ')' : '' }}
        </div>
      </el-form-item> -->
      <el-form-item
        required
        label="状态"
      >
        <el-select
          v-model="create.status"
          filterable
        >
          <el-option
            v-for="item in $key.myStore.status"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <z-map @returnMapInfo="returnMapInfo" />

    <div class="m-t-20 m-b-20 text-c">
      <el-button
        type="primary"
        @click="toSubmit"
      >
        确认
      </el-button>
      <el-button @click="callCreate.visible = false">
        取消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api/'
import Util from '@/utils'
import ZMap from '@/components/map'
import { mapState } from 'vuex'

function Create () {
  return {
    address: '',
    warehouseName: '',
    warehouseNo: '',
    marketId: '',
    marketName: '',
    lng: '',
    lat: '',
    status: '0',
    provinceName: '',
    cityName: '',
    districtName: '',
    companyId: '',
    companyName: '',
    warehouseType: 'WHOLESALER_APP'// 店铺仓库类型
  }
}
export default {
  name: 'WarehouseCreate',

  components: {
    ZMap,
  },

  props: {
    callCreate: {
      type: Object,
      default: () => { return { visible: false, type: '', detailInfo: {} } },
    },
    marketList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      create: new Create(),
      createRules: [
        { name: 'companyId', message: '店铺信息必传, 请先开通店铺' },
        { name: 'marketId', message: '市场必传' },
        { name: 'warehouseNo', message: '仓库编号必传' },
        { name: 'warehouseName', message: '仓库名称必传' },
        { name: 'address', message: '所在地必传' },
        { name: 'lng', message: '地理位置必传' },
        { name: 'status', message: '状态必传' },
      ],
      storeInfo: {}
    }
  },
  computed: {
    ...mapState({
      marketCodes: state => state.user.info.marketCodes
    })
  },
  created () {
    if (this.marketList.length === 1) {
      this.create.marketId = this.marketList[0].k
      this.selectMarketChange(this.create.marketId)
    }
    this.getStoreDetail()
  },
  mounted () {
    if (this.callCreate.type === 'edit') {
      this.create = { ...this.callCreate.detailInfo }
    }
  },
  methods: {
    // 店铺信息
    getStoreDetail () {
      api.myStore.getStoreDetail().then(res => {
        this.storeInfo = res.data
        this.create.companyId = this.storeInfo.id
        this.create.companyName = this.storeInfo.storeName
      })
    },
    selectMarketChange (val) {
      if (!val) return
      this.create.marketName = (this.marketList.find(item => item.k === val)).v
    },
    returnMapInfo (data) {
      this.create.lng = data.lng
      this.create.lat = data.lat
      this.create.address = data.address
      this.create.provinceName = data.addressDetail.province
      this.create.cityName = data.addressDetail.city
      this.create.districtName = data.addressDetail.district
    },
    toSubmit () {
      // 每个客户只有一个市场
      this.create.marketId = this.marketList.length ? this.marketList[0].k : ''
      if (Util.checkEmptyRules(this.create, this.createRules)) return
      api.myStore.createOrUpdateWarehouse(this.create).then(res => {
        this.$message.success('操作成功')
        this.$emit('close')
        this.$emit('refresh')
      })
    },

  },
}
</script>
<style lang="scss" scoped>
.amap-demo {
  height: 500px;
}
.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}
.w220 {
  width: 540px!important;
}

.amap-page-container {
  position: relative;
}
.stretch-icon {
  cursor: pointer;
  color: #02b9b9;
  float: right;
  margin-right: 64px;
  margin-top: 12px;
}
</style>
